import React from 'react';
import * as constants from '../../common/constants';
import NotificationModel from '../../common/components/notification/NotificationModel';
import AIAdminContainer from './AIAdminContainer';
import { TenantProvider } from './components/tenantContext/TenantContext';
import AddLLMTestSuite from './models/AddLLMTestSuite';
import AssetTOC from './models/AssetTOC';
import ChannelsListing from './models/ChannelsListing';
import ChannelsModel from './models/ChannelsModel';
import ChannelsSubType from './models/ChannelsSubType';
import ChannelsTrends from './models/ChannelsTrends';
import ChannelsUtility from './models/ChannelsUtility';
import ChatgptAdminPromptsData from './models/ChatGptAdminPrompts';
import ChatgptAdmin from './models/ChatgptAdmin';
import ChatgptUtilityIESUser from './models/ChatgptIESUser';
import Mapping from './models/ChatgptMapping';
import ChatgptUtility from './models/ChatgptUtility';
import ChatutilityBooks from './models/ChatutilityBooks';
import ChatutilityPermissions from './models/ChatutilityPermissions';
import ChatutilityRoles from './models/ChatutilityRoles';
import ChatutilityUsers from './models/ChatutilityUsers';
import ClusterList from './models/ClusterList';
import CommonSearchModel from './models/CommonSearchModel';
import Feedback from './models/Feedback';
import FileData from './models/FileData';
import GetBookTitlesDataModel from './models/GetBookTitlesDataModel';
import GetAuditGraphTitlesDataModel from './models/GetAuditGraphTitlesDataModel';
import GetObserveTypes from './models/GetObserveTypes';
import IngestionStatusModel from './models/IngestionStatus';
import Listing from './models/Listing';
import McqSearch from './models/McqSearch';
import ObserveSearchModel from './models/ObserveSearchModel';
import PopularPageModel from './models/PopularPage';
import GetSubtypesModel from './models/GetSubtypesModel';
import ProvidersListModel from './models/ProvidersList';
import Response from './models/Response';
import EffectivenessData from './models/StudyToolEffectiveness';
import SubTypeResponse from './models/SubTypeModel';
import Summary from './models/Summary';
import TenantConfigModel from './models/TenantConfig';
import TenantDataModel from './models/TenantData';
import TenantFeatureModel from './models/TenantFeatureModel';
import TenantsListModel from './models/TenantsList';
import Toc from './models/Toc';
import AetQuiz from './models/AetQuiz';
import AetTopic from './models/AetTopic';
import TrendingTopicByBook from './models/TrendingTopicByBook';
import TrendingTopics from './models/TrendingTopics';
import Trends from './models/Trends';
import TrendsBlockedChartsModel from './models/TrendsBlockedCharts';
import TrendsBlockedChartsDetailsModel from './models/TrendsBlockedChartsDetails';
import TrendsClusterList from './models/TrendsClusterList';
import TrendsCount from './models/TrendsCount';
import TrendsUserFeedbackDetailsModel from './models/TrendsUserFeedbackDetailsModel';
import TrendsUserFeedbackModel from './models/TrendsUserFeedbackModel';
import UserAuditFeedbackModel from './models/UserAuditFeedbackModel';
import UserAuditRequestModel from './models/UserAuditRequestModel';
import UserAuditSubRequestsModel from './models/UserAuditSubRequestsModel';
import AiAdminExecutionLogsModel from './models/AiAdminExecutionLogsModel';
import FeedbackOverlayModel from './models/FeedbackOverlayModel';
import PromptModelData from './models/prompt/PromptModels';
import PromptTypes from './models/prompt/PromptTypes';
import PromptVersionModel from './models/prompt/PromptVersion';
import UserPermissionCheck from './models/prompt/UserPermissionCheck';
import AddLLMTestSuiteService from './service/AddLLMTestSuiteService';
import AssetService from './service/AssetService';
import ChannelsModelService from './service/ChannelsModelService';
import ChannelsSubTypeService from './service/ChannelsSubTypeService';
import ChannelsUtilityService from './service/ChannelsUtilityService';
import ChannelsUtilityTrendsListingService from './service/ChannelsUtilityTrendsListingService';
import ChannelsUtilitytrendsService from './service/ChannelsUtilityTrendsService';
import ChatGptAddAdminPromptsService from './service/ChatGptAddAdminPromptsService';
import ChatGptEditAdminPromptsService from './service/ChatGptEditAdminPromptsService';
import ChatGptGetAdminPromptsService from './service/ChatGptGetAdminPromptsService';
import ChatGptPublishAllSummaryStatusUpdateService from './service/ChatGptPublishAllSummaryUpdateService';
import ChatGptUtilityFeedbackService from './service/ChatGptUtilityFeedbackService';
import ChatgptUtilityIESService from './service/ChatGptUtilityIESService';
import ChatGptUtilityListingService from './service/ChatGptUtilityListingService';
import ChatGptUtilityMappingService from './service/ChatGptUtilityMappingService';
import ChatGptUtilityResponseService from './service/ChatGptUtilityResponseService';
import ChatgptUtilityService from './service/ChatGptUtilityService';
import ChatGptUtilityTrendsService from './service/ChatGptUtilityTrendsService';
import ChatGptUtilitySubTypeService from './service/ChatUtilitySubTypeService';
import ChatgptAdminService from './service/ChatgptAdminService';
import ChatGptEditAdminService from './service/ChatgptEditAdminService';
import ChatGptGetAdminervice from './service/ChatgptGetAdminService';
import ChatutilityAddRolesService from './service/ChatutilityAddRolesService';
import ChatutilityAddBookService from './service/ChatutilityAddBookService';
import ChatutilityAddUserService from './service/ChatutilityAddUserService';
import ChatutilityBooksService from './service/ChatutilityBooksService';
import ChatutilityEditBookService from './service/ChatutilityEditBookService';
import ChatutilityEditUserService from './service/ChatutilityEditUserService';
import DeleteUserService from './service/DeleteUserService';
import ChatutilityPermissionsService from './service/ChatutilityPermissionService';
import ChatutilityRoleService from './service/ChatutilityRoleService';
import ChatutilityUpdateRolesService from './service/ChatutilityUpdateRolesService';
import ChatutilityUsersService from './service/ChatutilityUsersService';
import ClusterListService from './service/ClusterListService';
import CommonSearchUtilityService from './service/CommonSearchUtilityService';
import ContentMangtSummaryService from './service/ContentMangtSummaryService';
import ContentMgtSummaryStatusUpdateService from './service/ContentMgtSummaryStatusUpdateService';
import ContentMgtSummaryUpdateService from './service/ContentMgtSummaryUpdateService';
import ContentMgtTocAddService from './service/ContentMgtTocAddService';
import ContentMgtTocServic from './service/ContentMgtTocService';
import ContentmgtMcqEditService from './service/ContentmgtMcqEditService';
import AetQuizAddService from './service/AetQuizAddService';
import AetQuizEditService from './service/AetQuizEditService';
import AetQuizDeleteService from './service/AetQuizDeleteService';
import AetQuizPlaceholderService from './service/AetQuizPlaceholderService';
import GetTextContentService from './service/GetTextContentService';
import AetTopicAddService from './service/AetTopicAddService';
import AetTopicEditService from './service/AetTopicEditService';
import AetTopicDeleteService from './service/AetTopicDeleteService';
import AetTopicPlaceholderService from './service/AetTopicPlaceholderService';
import EffectivenessUploadService from './service/EffectivenessFileUploadService';
import EffectivenessInitiateService from './service/EffectivenessInitiateService';
import EffectivenessMetadataService from './service/EffectivenessMetadataService';
import EvalResultListService from './service/eval/EvalResultListService';
import EvalGraphRubricsService from './service/eval/EvalGraphRubricsService';
import EvalRubricNameSearchService from './service/eval/EvalRubricNameSearchService';
import EvalReportCompositeService from './service/eval/EvalReportCompositeService';
import EvalReportPanelScoreDetailService from './service/eval/EvalReportPanelScoreDetailService';
import EvalResultExecutionService from './service/eval/EvalResultExecutionService';
import EvalBatchReportService from './service/eval/EvalBatchReportService';
import EvalResultScoreDetailService from './service/eval/EvalResultScoreDetailService';
import RubricsListService from './service/eval/RubricsListService';
import RubricsDeleteService from './service/eval/RubricsDeleteService';
import RubricsDetailService from './service/eval/RubricsDetailService';
import RubricsUpdateService from './service/eval/RubricsUpdateService';
import RubricsCreateService from './service/eval/RubricsCreateService';
import RubricsSchedulerService from './service/eval/RubricsSchedulerService';
import CustomEvalService from '../../common/services/Evaluation/CustomEvalService';
import EvalReportData from './models/eval/EvalReportData';
import EvalResultData from './models/eval/EvalResultData';
import EvalGraphRubricsData from './models/eval/EvalGraphRubricsData';
import RubricsData from './models/eval/RubricsData';
import FileDataService from './service/FileDataService';
import GetBookTitlesService from './service/GetBookTitlesService';
import GetLLMTestSuiteService from './service/GetLLMTestSuiteService';
import GetObserveTypesService from './service/GetObserveTypesService';
import GetProvidersListService from './service/GetProvidersListService';
import GetSys2sysTokenService from './service/GetSys2sysTokenService';
import GetTenantConfigService from './service/GetTenantConfigService';
import GetTenantListService from './service/GetTenantListService';
import GetTrendingTopicsService from './service/GetTrendingTopicsService';
import GetPVSIngestionData from './service/IngestionStatusService';
import LLMTestResultsService from './service/LLMTestResultsService';
import LLMTestResultsByExecutionService from './service/LLMTestResultsByExecutionService';
import McqPublishAllStatusUpdateService from './service/McqPublishAllStatusUpdateService';
import McqStatusDeleteService from './service/McqStatusDeleteService';
import McqStatusUpdateService from './service/McqStatusUpdateService';
import McqUtilityBookSearchService from './service/McqUtilityBookSearchService';
import ObserveSearchService from './service/ObserveSearchService';
import ObserveExportService from './service/ObserveExportService';
import TrendsClusterExportService from './service/trends/TrendsClusterExportService';
import TrendsCountExportService from './service/trends/TrendsCountExportService';
import TrendsFeedbackChartsExportService from './service/trends/TrendsFeedbackChartsExportService';
import TrendsBlockedChartsExportService from './service/trends/TrendsBlockedChartsExportService';
import SearchListExportService from './service/SearchListExportService';
import PopularPagesService from './service/PopularPagesService';
import GetSubtypesService from './service/GetSubtypesService';
import StudyToolEffectivenessService from './service/StudyToolEffectivenessService';
import TrendingTopicsService from './service/TrendingTopicsService';
import TrendsBlockedChartsDetails from './service/TrendsBlockedChartsDetails';
import TrendsBlockedChartsService from './service/TrendsBlockedChartsService';
import TrendsClusterListService from './service/TrendsClusterListService';
import TrendsCountService from './service/TrendsCountService';
import TrendsFeedbackChartsDetailsService from './service/TrendsFeedbackChartsDetailsService';
import TrendsFeedbackChartsService from './service/TrendsFeedbackChartsService';
import UserAuditFeedbackService from './service/UserAuditFeedbackService';
import UserAuditRequestService from './service/UserAuditRequestService';
import UserAuditSubRequestsService from './service/UserAuditSubRequestsService';
import GetTenantFeatureService from './service/configuration/GetTenantFeatureService';
import UpdateTenantFeatureService from './service/configuration/UpdateTenantFeatureService';
import AddTenantFeatureService from './service/configuration/AddTenantFeatureService';
import GetPromptModelNamesService from './service/prompt/GetPromptModelNames';
import GetPromptVersionService from './service/prompt/GetPromptVersionService';
import PromptGetTypesService from './service/prompt/PromptGetTypesService';
import GetPromptPropertiesService from './service/prompt/GetPromptPropertiesService';
import UpdatePromptPropertiesService from './service/prompt/UpdatePromptPropertiesService';
import PromptProperties from './models/prompt/PromptProperties';
import FeedbackModel from './models/FeedbackModel';
import FeedbackLogsModel from './models/feedback/FeedbackLogsModel';
import FeedbackLogsService from './service/feedback/FeedbackLogsService';
import FeedbackExportService from './service/feedback/FeedbackExportService';
import FeedbackDetailedLogModel from './models/feedback/FeedbackDetailedLogModel';
import FeedbackDetailedLogService from './service/feedback/FeedbackDetailedLogService';
import GetAiAdminExecutionLogsService from './service/GetAiAdminExecutionLogsService';
import McqCommentService from './service/McqCommentService';
import SummaryCommentService from './service/SummaryCommentService';
import AgenticGraphListModel from './models/agentic/AgenticGraphListModel';
import AgenticGraphModel from './models/agentic/AgenticGraphModel';
import AgenticPromptModel from './models/agentic/AgenticPromptModel';
import GetAgenticGraphListService from './service/agentic/GetAgenticGraphListService';
import GetAgenticGraphService from './service/agentic/GetAgenticGraphService';
import GetAgenticPromptVersionsService from './service/agentic/GetAgenticPromptVersionsService';
import GetAgenticPromptVersionService from './service/agentic/GetAgenticPromptVersionService';
import UpdateAgenticPromptService from './service/agentic/UpdateAgenticPromptService';
import GetPromptCatalogueService from './service/agentic/GetPromptCatalogueService';
import GetPromptNameAvailabilityService from './service/agentic/GetPromptNameAvailabilityService';
import GetPromptVersionGraphsService from './service/agentic/GetPromptVersionGraphsService';
import CreateAgenticPromptService from './service/agentic/CreateAgenticPromptService';
import GetAgenticPromptHistoryService from './service/agentic/GetAgenticPromptHistoryService';
import TelemetrySearchService from './telemetry/service/TelemetrySearchService';
import TelemetryDetailService from './telemetry/service/TelemetryDetailService';
import TelemetrySearchModel from './telemetry/models/TelemetrySearchModel';
import TelemetryDetailModel from './telemetry/models/TelemetryDetailModel';
import OtelTrendsCountService from './telemetry/trends/service/OtelTrendsCountService';
import OtelTrendsCountExportService from './telemetry/trends/service/OtelTrendsCountExportService';
import OtelTrendsCount from './telemetry/trends/models/OtelTrendsCount';

export default {
  path: [
    '/aiadmin/aistudytools',
    '/aiadmin/aistudytools/feedback',
    '/aiadmin/aistudytools/trends',
    '/aiadmin/aistudytools/trends/charts',
    '/aiadmin/aistudytools/trends/clustering',
    '/aiadmin/aistudytools/trends/unanswered',
    '/aiadmin/aistudytools/mcq/view/:bookId',
    '/aiadmin/aistudytools/mcq/view',
    '/aiadmin/aistudytools/mcq/add/:bookId',
    '/aiadmin/aistudytools/mcq/add',
    '/aiadmin/aistudytools/mcq/edit',
    '/aiadmin/aistudytools/mcq/edit/:bookId',
    '/aiadmin/aistudytools/titlesearch',
    '/',
    '/dashboard',
    '/aiadmin',
    '/aiadmin/channels',
    '/aiadmin/channels/feedback',
    '/aiadmin/channels/trends',
    '/aiadmin/admin',
    '/aiadmin/aistudytools/summary/view/:bookId',
    '/aiadmin/aistudytools/summary/view',
    '/aiadmin/aistudytools/summary/add/:bookId',
    '/aiadmin/aistudytools/summary/add',
    '/aiadmin/aistudytools/summary/edit',
    '/aiadmin/aistudytools/summary/edit/:bookId',
    '/aiadmin/aistudytools/trends/effectiveness',
    '/aiadmin/aistudytools/promptmgt',
    '/aiadmin/aistudytools/promptmgt/effectiveness',
    '/aiadmin/aistudytools/agentic/prmptmgmt',
    '/aiadmin/aistudytools/agentic/prmptmgmt/:promptRef',
    '/aiadmin/channels/promptmgt',
    '/aiadmin/tenants',
    '/aiadmin/users',
    '/aiadmin/roles',
    '/aiadmin/popularpage',
    '/aiadmin/pvsassessment',
    '/aiadmin/pvsassessment/selectlesson',
    '/aiadmin/pvsassessment/selectlesson/chapter',
    '/aiadmin/chatbotconfig',
    '/aiadmin/aitrendingtopics',
    '/aiadmin/psv/ingestion',
    '/aiadmin/aitestsuite',
    '/aiadmin/*'
  ],
  exact: true,
  // services: [
  //   new CommonSearchUtilityService(),
  // ],
  services: [
    new ChatgptUtilityService(),
    new ChatGptUtilityFeedbackService(),
    new ChatGptUtilityResponseService(),
    new ChatgptUtilityIESService(),
    new ChatGptUtilityTrendsService(),
    new ChatGptUtilityMappingService(),
    new ChatGptUtilitySubTypeService(),
    new ChatGptUtilityListingService(),
    new ClusterListService(),
    new AssetService(),
    new ContentMgtTocServic(),
    new ContentMangtSummaryService(),
    new ContentMgtSummaryUpdateService(),
    new ContentMgtSummaryStatusUpdateService(),
    new ContentmgtMcqEditService(),
    new ContentMgtTocAddService(),
    new AetQuizAddService(),
    new AetQuizEditService(),
    new AetQuizDeleteService(),
    new AetQuizPlaceholderService(),
    new GetTextContentService(),
    new AetTopicAddService(),
    new AetTopicEditService(),
    new AetTopicDeleteService(),
    new AetTopicPlaceholderService(),
    new McqStatusDeleteService(),
    new McqStatusUpdateService(),
    new McqCommentService(),
    new SummaryCommentService(),
    new McqUtilityBookSearchService(),
    new ChannelsUtilityService(),
    new ChannelsUtilityTrendsListingService(),
    new ChannelsUtilitytrendsService(),
    new ChannelsSubTypeService(),
    new ChannelsModelService(),
    new ChatgptAdminService(),
    new ChatGptGetAdminervice(),
    new ChatGptEditAdminService(),
    new ChatGptGetAdminPromptsService(),
    new ChatGptAddAdminPromptsService(),
    new ChatGptEditAdminPromptsService(),
    new StudyToolEffectivenessService(),
    new EffectivenessInitiateService(),
    new EffectivenessUploadService(),
    new EffectivenessMetadataService(),
    new EvalResultListService(),
    new EvalGraphRubricsService(),
    new EvalRubricNameSearchService(),
    new EvalReportCompositeService(),
    new EvalReportPanelScoreDetailService(),
    new EvalResultExecutionService(),
    new EvalBatchReportService(),
    new EvalResultScoreDetailService(),
    new RubricsListService(),
    new RubricsDeleteService(),
    new RubricsDetailService(),
    new RubricsUpdateService(),
    new RubricsCreateService(),
    new RubricsSchedulerService(),
    new CustomEvalService(),
    new McqPublishAllStatusUpdateService(),
    new ChatGptPublishAllSummaryStatusUpdateService(),
    new CommonSearchUtilityService(),
    new ChatutilityUsersService(),
    new ChatutilityRoleService(),
    new ChatutilityAddUserService(),
    new ChatutilityEditUserService(),
    new DeleteUserService(),
    new ChatutilityAddRolesService(),
    new ChatutilityPermissionsService(),
    new ChatutilityUpdateRolesService(),
    new ChatutilityBooksService(),
    new ChatutilityAddBookService(),
    new ChatutilityEditBookService(),
    new PopularPagesService(),
    new GetSubtypesService(),
    new TrendsFeedbackChartsService(),
    new TrendsBlockedChartsService(),
    new TrendingTopicsService(),
    new GetTrendingTopicsService(),
    new TrendsFeedbackChartsDetailsService(),
    new TrendsBlockedChartsDetails(),
    new FileDataService(),
    new AddLLMTestSuiteService(),
    new GetLLMTestSuiteService(),
    new LLMTestResultsService(),
    new LLMTestResultsByExecutionService(),
    new GetTenantListService(),
    new GetProvidersListService(),
    new GetBookTitlesService(),
    new GetBookTitlesService(
      constants.FETCH_AUDIT_GRAPH_TITLES_DATA,
      constants.AUDIT_GRAPH_TITLES_SERVICE_STATUS,
      constants.AUDIT_GRAPH_TITLES_STORE,
      { notifyWhenEmpty: false }
    ),
    new GetObserveTypesService(),
    new GetSys2sysTokenService(),
    new ObserveSearchService(),
    new ObserveExportService(),
    new UserAuditRequestService(),
    new UserAuditSubRequestsService(),
    new TrendsClusterListService(),
    new TrendsCountService(),
    new TrendsClusterExportService(),
    new TrendsCountExportService(),
    new TrendsFeedbackChartsExportService(),
    new TrendsBlockedChartsExportService(),
    new SearchListExportService(),
    new GetPVSIngestionData(),
    new UserAuditFeedbackService(),
    new GetTenantFeatureService(),
    new UpdateTenantFeatureService(),
    new AddTenantFeatureService(),
    new GetPromptModelNamesService(),
    new GetPromptVersionService(),
    new PromptGetTypesService(),
    new GetPromptPropertiesService(),
    new UpdatePromptPropertiesService(),
    new FeedbackLogsService(),
    new FeedbackExportService(),
    new FeedbackDetailedLogService(),
    new GetTenantConfigService(),
    new GetAiAdminExecutionLogsService(),
    new GetAgenticGraphListService(),
    new GetAgenticGraphService(),
    new GetAgenticPromptVersionsService(),
    new GetAgenticPromptVersionService(),
    new UpdateAgenticPromptService(),
    new GetPromptCatalogueService(),
    new GetPromptNameAvailabilityService(),
    new GetPromptVersionGraphsService(),
    new CreateAgenticPromptService(),
    new GetAgenticPromptHistoryService(),
    new TelemetrySearchService(),
    new TelemetryDetailService(),
    new OtelTrendsCountService(),
    new OtelTrendsCountExportService()
  ],

  stores: [
    {
      name: 'effectivenessData',
      spec: EffectivenessData,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'evalReportData',
      spec: EvalReportData,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'evalResultData',
      spec: EvalResultData,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'evalGraphRubricsData',
      spec: EvalGraphRubricsData,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'rubricsData',
      spec: RubricsData,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'ChatgptUtilityIESUserData',
      spec: ChatgptUtilityIESUser,
      saveLocally: false,
      initialState: {
        userData: []
      }
    },
    {
      name: 'chatgptUtility',
      spec: ChatgptUtility,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'chatgptFeedbackUtility',
      spec: Feedback,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'chatgptResponseUtility',
      spec: Response,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'ChatUtilitySubTypeResponse',
      spec: SubTypeResponse,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'chatgptTrendsUtility',
      spec: Trends,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'chatgptMappingUtility',
      spec: Mapping,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'chatgptListingUtility',
      spec: Listing,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'assetTOC',
      spec: AssetTOC,
      saveLocally: false,
      initialState: {
        id: '',
        title: '',
        children: [
          {
            id: '',
            title: '',
            type: '',
            assetType: '',
            uri: '',
            required: false
          }
        ]
      }
    },
    {
      name: 'chatgptTocUtility',
      spec: Toc,
      saveLocally: false,
      initialState: {
        chatgptUtility: {}
      }
    },
    {
      name: 'aetQuizUtility',
      spec: AetQuiz,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'aetTopicUtility',
      spec: AetTopic,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'chatgptSummaryUtility',
      spec: Summary,
      saveLocally: false,
      initialState: {
        chatgptSummaryUtility: {}
      }
    },
    {
      name: 'titleSearch',
      spec: McqSearch,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'channelsUtility',
      spec: ChannelsUtility,
      saveLocally: false,
      initialState: {
        channelsUtility: {}
      }
    },
    {
      name: 'channelsSubType',
      spec: ChannelsSubType,
      saveLocally: false,
      initialState: {
        channelsSubType: {}
      }
    },
    {
      name: 'channelsListingUtility',
      spec: ChannelsListing,
      saveLocally: false,
      initialState: {
        channelsUtility: {}
      }
    },
    {
      name: 'channelsTrendsUtility',
      spec: ChannelsTrends,
      saveLocally: false,
      initialState: {
        channelsUtility: {}
      }
    },
    {
      name: 'channelsModelData',
      spec: ChannelsModel,
      saveLocally: false,
      initialState: {
        channelsModelData: {}
      }
    },
    {
      name: 'chatgptAdmin',
      spec: ChatgptAdmin,
      saveLocally: false,
      initialState: {
        chatgptAdmin: {}
      }
    },
    {
      name: 'chatgptAdminPrompts',
      spec: ChatgptAdminPromptsData,
      saveLocally: false,
      initialState: {
        chatgptAdminPrompts: {}
      }
    },
    {
      name: 'commonSearchUtility',
      spec: CommonSearchModel,
      saveLocally: false,
      initialState: {
        commonSearchUtility: {}
      }
    },
    {
      name: 'observeSearch',
      spec: ObserveSearchModel,
      saveLocally: false,
      initialState: {
        observeSearch: {}
      }
    },
    {
      name: 'telemetrySearch',
      spec: TelemetrySearchModel,
      saveLocally: false,
      initialState: {
        telemetrySearch: {}
      }
    },
    {
      name: 'telemetryDetail',
      spec: TelemetryDetailModel,
      saveLocally: false,
      initialState: {
        data: {},
        tracingData: {},
        selectedRecordIndex: 0,
        isOverlayOpen: false,
        isLoading: false
      }
    },
    {
      name: 'feedback',
      spec: FeedbackModel,
      saveLocally: false,
      initialState: {
        feedback: {}
      }
    },
    {
      name: 'feedbackLogs',
      spec: FeedbackLogsModel,
      saveLocally: false,
      initialState: {
        data: [],
        pagination: {
          offset: 0,
          limit: constants.PAGINATION.LIMIT,
          totalCount: 0,
          totalPages: 0,
          currentPage: 1
        },
        currentPage: 1,
        pageSize: constants.PAGINATION.LIMIT,
        hasReachedEnd: false,
        lastPayload: {}
      }
    },
    {
      name: 'feedbackDetailedLog',
      spec: FeedbackDetailedLogModel,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'chatutilityusersState',
      spec: ChatutilityUsers,
      saveLocally: false,
      initialState: {
        data: [],
        addUser: '',
        updateUser: ''
      }
    },
    {
      name: 'chatutilityuserRoles',
      spec: ChatutilityRoles,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'chatutilityrolesState',
      spec: ChatutilityRoles,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'chatutilityuserPermissions',
      spec: ChatutilityPermissions,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'chatutilitybooksState',
      spec: ChatutilityBooks,
      saveLocally: false,
      initialState: {
        data: [],
        status: null
      }
    },
    {
      name: 'popularPages',
      spec: PopularPageModel,
      saveLocally: false,
      initialState: {
        popularPages: {}
      }
    },
    {
      name: 'getSubtypes',
      spec: GetSubtypesModel,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'trendsFeedbackChartsUtility',
      spec: TrendsUserFeedbackModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'trendsBlockedCharts',
      spec: TrendsBlockedChartsModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'trendsBlockedChartsDetails',
      spec: TrendsBlockedChartsDetailsModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'aiFeedbackChartsDetails',
      spec: TrendsUserFeedbackDetailsModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'trendingTopics',
      spec: TrendingTopics,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'trendingTopicByBook',
      spec: TrendingTopicByBook,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'fileData',
      spec: FileData,
      saveLocally: false,
      initialState: {
        mathJaxVersion: {}
      }
    },
    {
      name: 'llmEvaluationTestSuiteData',
      spec: AddLLMTestSuite,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'tenantsList',
      spec: TenantsListModel,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'providersList',
      spec: ProvidersListModel,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'notificationState',
      spec: NotificationModel,
      saveLocally: false,
      initialState: {
        notificationState: {}
      }
    },
    {
      name: 'clusterList',
      spec: ClusterList,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'tenantConfig',
      spec: TenantConfigModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'tenantData',
      spec: TenantDataModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'bookTitles',
      spec: GetBookTitlesDataModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: constants.AUDIT_GRAPH_TITLES_STORE,
      spec: GetAuditGraphTitlesDataModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'agenticGraphListModel',
      spec: AgenticGraphListModel,
      saveLocally: false,
      initialState: {
        graphs: [],
        error: null
      }
    },
    {
      name: 'agenticGraphModel',
      spec: AgenticGraphModel,
      saveLocally: false,
      initialState: {
        graphData: null,
        error: null
      }
    },
    {
      name: 'agenticPromptModel',
      spec: AgenticPromptModel,
      saveLocally: false,
      initialState: {
        activeResolved: null,
        versions: [],
        lastError: null,
        lastMutation: null
      }
    },
    {
      name: 'observeTypes',
      spec: GetObserveTypes,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'userAuditRequest',
      spec: UserAuditRequestModel,
      saveLocally: false,
      initialState: {
        data: [],
        selectedRecordIndex: 0,
        isOverlayOpen: false,
        isFromTrendsInsights: false
      }
    },
    {
      name: 'aiAdminExecutionLogs',
      spec: AiAdminExecutionLogsModel,
      saveLocally: false,
      initialState: {
        executionLogs: null,
        error: null
      }
    },
    {
      name: 'ingestionData',
      spec: IngestionStatusModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'userAuditSubRequests',
      spec: UserAuditSubRequestsModel,
      saveLocally: false,
      initialState: {
        data: {}
      }
    },
    {
      name: 'userAuditFeedback',
      spec: UserAuditFeedbackModel,
      saveLocally: false,
      initialState: {
        data: {}
      }
    },
    {
      name: 'feedbackOverlay',
      spec: FeedbackOverlayModel,
      saveLocally: false,
      initialState: {
        data: [],
        selectedRecordIndex: 0,
        isOverlayOpen: false
      }
    },
    {
      name: 'tenantFeature',
      spec: TenantFeatureModel,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'trendsClusterListUtility',
      spec: TrendsClusterList,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'trendsCountUtility',
      spec: TrendsCount,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'otelTrendsCount',
      spec: OtelTrendsCount,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'userPermissionCheck',
      spec: UserPermissionCheck,
      saveLocally: false,
      initialState: {
        isPermissionCheck: false
      }
    },
    {
      name: 'promptModels',
      spec: PromptModelData,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'promptVersion',
      spec: PromptVersionModel,
      saveLocally: false,
      initialState: {}
    },
    {
      name: 'promptGetTypes',
      spec: PromptTypes,
      saveLocally: false,
      initialState: {
        data: []
      }
    },
    {
      name: 'promptProperties',
      spec: PromptProperties,
      saveLocally: false,
      initialState: {
        promptProperties: {}
      }
    }
  ],
  render: (props) => (
    <TenantProvider>
      <AIAdminContainer {...props} />
    </TenantProvider>
    // eslint-disable-line react/prop-types
  )
};
